 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		68: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		var threw = true;
 		try {
 			modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 			threw = false;
 		} finally {
 			if(threw) delete installedModules[moduleId];
 		}

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = 'text/javascript';
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "" + ({"0":"bundles/pages/indexOld.js","1":"bundles/pages/index.js","2":"bundles/pages/single-fund.js","3":"bundles/pages/single-fund-new.js","4":"bundles/pages/grow-wealth.js","5":"bundles/pages/dashboard.js","6":"bundles/pages/plan.js","7":"bundles/pages/search.js","8":"bundles/pages/compare-funds.js","9":"bundles/pages/kyc.js","10":"bundles/pages/sip-calculator.js","11":"bundles/pages/mfHome.js","12":"bundles/pages/nfos.js","13":"bundles/pages/plan-v2.js","14":"bundles/pages/save-taxes.js","15":"bundles/pages/amc.js","16":"bundles/pages/amcNew.js","17":"bundles/pages/profile.js","18":"bundles/pages/currency.js","19":"bundles/pages/elss-calculator.js","20":"bundles/pages/personalized-plan.js","21":"bundles/pages/personalised-plan.js","22":"bundles/pages/f2s.js","23":"bundles/pages/invest.js","24":"bundles/pages/google-auth.js","25":"bundles/pages/postFiling.js","26":"bundles/pages/whatsapp-confirmation.js","27":"bundles/pages/nfoDetails.js","28":"bundles/pages/mandate.js","29":"bundles/pages/_error.js","30":"bundles/pages/filing-to-save.js","31":"bundles/pages/currency/components/banner/Banner.js","32":"bundles/pages/currency/components/Conversionfold/Graph/Graph.js","33":"bundles/pages/complete-kyc.js","34":"bundles/pages/rent-page.js","35":"bundles/pages/amcs.js","36":"bundles/pages/currency/components/FAQ/Faq.js","37":"bundles/pages/special-referral.js","38":"bundles/pages/login.js","39":"bundles/pages/currency/components/Conversionfold/Graph/graphConstant.js","40":"bundles/pages/currency/components/Conversionfold/Converter/converter.js","41":"bundles/pages/currency/components/Aboutcurrenies/Aboutcurrenies.js","42":"bundles/pages/currency/components/Popularconversions/Popularconversions.js","43":"bundles/pages/calculator80C.js","44":"bundles/pages/status.js","45":"bundles/pages/redirect.js","46":"bundles/pages/yesBankCrisisFaq.js","47":"bundles/pages/referral.js","48":"bundles/pages/refer.js","49":"bundles/pages/redeemSummary.js","50":"bundles/pages/paymentSuccess.js","51":"bundles/pages/payment.js","52":"bundles/pages/mandate-status.js","53":"bundles/pages/logout.js","54":"bundles/pages/indexMobile.js","55":"bundles/pages/help.js","56":"bundles/pages/demo.js","57":"bundles/pages/dashboardRedirect.js","58":"bundles/pages/currency/currencyConst.js","59":"bundles/pages/currency/components/FAQ/faqdropdown/faqdropdown.js","60":"bundles/pages/currency/components/Conversionfold/Converter/ConverterInput/ConverterInput.js","61":"bundles/pages/currency/components/Commondenominations/Commondenominations.js","62":"bundles/pages/currency/components/Aboutcurrenies/CurrencyInformation/CurrencyInformation.js","63":"bundles/pages/currency/api.js","64":"bundles/pages/complete-payment.js","65":"bundles/pages/appIssues.js","66":"bundles/pages/currency/util/recaptcha.js","67":"bundles/pages/currency/components/Navbar/Productmenu/ProductsMenu.js"}[chunkId]||chunkId) + "-" + {"0":"858f3c40aee2662e49ea","1":"28ae1c8bfddaa37e8269","2":"d9cfd8bedb7e7abc21d1","3":"d344b2a3cbed8425a828","4":"d2d9e2314e21201c907d","5":"8998660d8c84eda7b85a","6":"84fbc83a3b37f0e828e8","7":"b032547f8658af5675a7","8":"aa82163075c3f04fba2d","9":"d3c8684f800fb758f23d","10":"749492cfabb1323a0646","11":"1b4bc552dac7e21a1eaa","12":"a77fc18ca3bfabf10b24","13":"ee95fcccdb8e7fc5a904","14":"76776e03d6d87480b6e5","15":"320e3228a6796dfabb88","16":"9ef14cd1150b54df4f77","17":"2f13de90c0e618142d9f","18":"9058677c7d06ca2e0a91","19":"6ee9dc41230271bdfa70","20":"e118c102cab4e375d152","21":"abbb94d55ce038d47467","22":"67e285c0ea92ede9cd9b","23":"22e49e2cd32fbb96f5ed","24":"a917b73c99ba4e39873c","25":"235642c8e3f99a54011c","26":"cb4535401761453dbb02","27":"e0467f0277a7d49840da","28":"6a5b80b5ff7a16c03359","29":"80fa6eedad8eecae784b","30":"7bbbf13f63cad4719555","31":"6f9f63f614726bf01300","32":"2b285620261032766fd2","33":"d54c2fd60cbf8d6e7662","34":"21e051034c6c6fffbe53","35":"9208cb607ee296a57ee9","36":"8b0a31e4ee23e95b5efe","37":"763ad43894fb66400503","38":"a2c08a1b52a6d339d8de","39":"ca16956b29b8981f3880","40":"0de6d8b9fe1c79fed64d","41":"4d0b120fc2fdd44a67c9","42":"882b7fefbccfb419e9f3","43":"bc830a8b49bf30f37647","44":"2dc2e2816b540d93b0a3","45":"4ed58438136f4b6edb3d","46":"36c24d1c991315a43654","47":"fb33fc2083f2de87d500","48":"d177344065ae985619a9","49":"5986eca1b3a8d2f00ae5","50":"a58b8c0033fdd693ab19","51":"e516afd854d3c52c6c2d","52":"2f245428df2598d4d7c0","53":"d401807a16620727bfcf","54":"0836165dc993b84a3f3d","55":"ab20d96776ab1bca13ab","56":"31b9b160053eb8fa3842","57":"90eaa076881e429063f5","58":"922a4ba86282d689bfa3","59":"31a86eeaf897a7416ba5","60":"644e525db64b30f8e23f","61":"34a0b6d273d57c5c62d8","62":"919a85c7c9edfe6854e3","63":"bb16123cad31693b386f","64":"34e8eb55d6284335ec55","65":"8b7fa9975904c6b417b0","66":"de44cae9d25d73941d4d","67":"032b5de26aeffa130d6f"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 754);



// WEBPACK FOOTER //
// webpack/bootstrap fc5629f6a6b5bfbdfd10